package com.eladfinish.bible.contest.screens.search.usecases.facts

import com.eladfinish.bible.contest.screens.search.model.VerseUiModel
import dev.icerock.moko.resources.desc.StringDesc
import kotlinx.collections.immutable.ImmutableList

sealed interface SpecialSearchResult {

    val wasInterrupted: Boolean
    val latestPlace: StringDesc?

    data class Items(
        val results: ImmutableList<VerseUiModel>,
        override val wasInterrupted: Boolean,
        override val latestPlace: StringDesc?,
    ) : SpecialSearchResult

    data class Summary(
        val message: StringDesc,
        override val wasInterrupted: Boolean,
        override val latestPlace: StringDesc?,
    ) : SpecialSearchResult
}
